import {AfterViewInit, Component, OnInit, ViewChild} from "@angular/core";
import {MatDialog} from "@angular/material/dialog";
import {DialogsService} from "../../../services/dialogs.service";
import {SnackService} from "../../../services/snack.service";
import {Router} from "@angular/router";
import {StorageService} from "../../../services/storage.service";
import {EMPTY, Observable, of} from "rxjs";
import {switchMap, tap} from "rxjs/operators";
import {MatTableDataSource} from "@angular/material/table";
import {Constants} from "../../../utils/constants";
import {MatPaginator} from "@angular/material/paginator";
import {Storage} from "../../../model/storage";
import {Sort} from "@angular/material/sort";
import {
  GeneralItemDetailDialogComponent
} from "../../../shared-components/general-item-detail-dialog/general-item-detail-dialog.component";
import {CreateStorageDialogComponent} from "../create-storage-dialog/create-storage-dialog.component";

@Component({
  selector: 'aw-list-storage',
  templateUrl: './list-storage.component.html',
  styleUrls: ['./list-storage.component.scss']
})
export class ListStorageComponent implements OnInit, AfterViewInit {

  public displayedColumns = [

    'testbed',
    'bucketId',
    'totalSpace',
    'filesCount',
    'usage',
    'action'
  ];

  @ViewChild('paginatorStorage') paginatorUsers!: MatPaginator;
  loading = false;
  entities = Constants.entities;
  dataSource!: MatTableDataSource<Storage>;
  disabled = false;
  disabledItemId: number[] = [];
  private allStorage$!: Observable<Storage[]>;

  constructor(
    public dialog: MatDialog,
    private storageService: StorageService,
    private dialogsService: DialogsService,
    private snackService: SnackService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.allStorage$ =
      of(true)
        .pipe(
          tap(() => this.loading = true),
          switchMap(() => this.storageService.getAllStorage()),
          tap(x => {
            this.dataSource = new MatTableDataSource<Storage>(x);
            this.dataSource.paginator = this.paginatorUsers;
            this.loading = false;
          })
        );
    this.allStorage$.subscribe();
  }


  applyFilters(event: string): void {
    this.dataSource.filter = event.trim().toLowerCase();
  }

  doSortStorage(event: Sort): void {
    this.dataSource.paginator?.firstPage();
    this.dataSource.data = this.dataSource.data.sort((a, b) => {

      const index: string = event.active;

      if (index === 'testbed') {
        if (event.direction === 'asc') {
          return ('' + b.testbed?.identifier).localeCompare('' + a.testbed?.identifier);
        } else {
          return ('' + a.testbed?.identifier).localeCompare('' + b.testbed?.identifier);
        }
      }

      if (event.direction === 'asc') {
        return ('' + (b as any)[index]).localeCompare('' + (a as any)[index]);
      } else {
        return ('' + (a as any)[index]).localeCompare('' + (b as any)[index]);
      }


    });
  }

  details(storage: Storage): void {
    this.dialog.open(GeneralItemDetailDialogComponent, { data: storage });
  }

  createStorage(): void {
    this.disabled = true;
    this.dialog
      .open(CreateStorageDialogComponent, { data: { storage: new Storage() } })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allStorage$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  editStorage(storage: Storage): void {
    this.disabled = false;
    this.dialog
      .open(CreateStorageDialogComponent, { data: { storage: storage } })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allStorage$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  deleteStorage(storage: Storage): void {
    this.disabled = true;
    const id = storage.id ?? -1;
    this.disabledItemId.push(id);

    const message = storage.filesCount === 0 ?
      `Are you sure you want to delete the storage for testbed ${storage.testbed?.identifier}` :
      `The storage contains ${storage.filesCount} files, by deleting the storage all the contained files will be lost.

       Are you sure you want to delete the storage for testbed ${storage.testbed?.identifier}`;


    this.dialogsService
      .confirm('Delete Storage', message, true)
      .pipe(
        switchMap((value) => value ?
          this.storageService.deleteStorage(<number>storage.id) :
          EMPTY),
        switchMap(() => this.allStorage$)
      )
      .subscribe(() => {
        this.disabled = false;
        this.snackService.success('Storage deleted!');
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
      }, (error) => {
        this.snackService.error(error.message);
        this.disabled = false;
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
      },
        () => {
          this.disabled = false;
          this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
        });

  }

}
